/** @jsxImportSource @emotion/react */
import Header from '../components/header';
import Review from '../components/review';
import ReviewSelect from '../components/review-select';
import Slider from '../components/slider';

const S5Desktop = ({ selectReview, currentReviewIndex, reviews }) => (
  <div
    css={{
      alignItems: 'stretch',
      flexDirection: 'row',
      '>div:nth-of-type(1)': {
        width: 'calc(50% - 15px)',
        marginRight: 15,
        '@media (min-width:992px)': { paddingBottom: 50 },
        '@media (min-width:1366px)': { width: 'calc(50% - 25px)', marginRight: 25 },
      },
      '>div:nth-of-type(2)': {
        width: 'calc(50%)',
        paddingLeft: 15,
        '@media (min-width:992px)': { paddingBottom: 20 },
        '@media (min-width:1366px)': { width: 'calc(50%)', paddingLeft: 25 },
      },
      width: '100%',
      minHeight: 545,
    }}
  >
    <div css={{ flexDirection: 'column', justifyContent: 'space-between' }}>
      <Header />
      <Review
        currentReviewIndex={currentReviewIndex}
        reviews={reviews}
        css={{ marginBottom: 30 }}
      />
      <ReviewSelect
        currentReviewIndex={currentReviewIndex}
        selectReview={selectReview}
        reviews={reviews}
      />
    </div>

    <Slider currentReviewIndex={currentReviewIndex} selectReview={selectReview} reviews={reviews} />
  </div>
);

export default S5Desktop;
